export default __webpack_public_path__ + "static/media/8.6992c946.png";